import { WSChat, formatDate } from './chat';
import { AdminApiConnector } from './admin_api_connector';
import { AdminPusherConnector } from './admin_pusher_connector';
import { EVENTS } from './events';
import { EmojiButton } from '@joeattardi/emoji-button';
import UserMetaInfo from './components/user_meta_info.html'
import { ConversationBuilder  } from './themes/bubble/conversation_builder';
import {DeletePlugin} from './plugins/delete';
import {WoocommercePlugin} from './plugins/woocommerce';
import {SearchPlugin} from './plugins/search';
import {TagsPlugin} from './plugins/tags';

jQuery(document).ready(function() {
    const wrapper = jQuery('.wschat-wrapper');

    if (wrapper.length === 0) {
    	return;
    }

    const CHAT_BUBBLE_TEMPLATE = `
		  <div class="row g-0 w-100 message-item" data-message-id="{{MESSAGE_ID}}">
			<div class="col-xs-10 col-md-9 col-lg-6 {{OFFSET}}">
			  <div class="chat-bubble chat-bubble--{{POS}}">
                <div class="message-item-action-badges"></div>
                {{CONTENT}}
			  </div>
              <span class="time">{{TIMESTAMP}}</span>
			</div>
		  </div>`;

    const BUBBLE_TEMPLATE_DEFAULTS = {
        '{{OFFSET}}': '',
        '{{POS}}': 'left',
        '{{CONTENT}}': '',
        '{{TIMESTAMP}}': '',
        '{{MESSAGE_ID}}': '',
    };

    jQuery.ajaxSetup({
        data: {
            wschat_ajax_nonce: wschat_ajax_obj.nonce
        }
    });

    var chat = new WSChat(jQuery('.wschat-wrapper'), {
        connector: wschat_ajax_obj.settings.communication_protocol === 'pusher' ? AdminPusherConnector : AdminApiConnector,
        api: {
            endpoint: wschat_ajax_obj.ajax_url,
            interval: 5000,
            wschat_ajax_nonce: wschat_ajax_obj.nonce,
            pusher: {
				key: wschat_ajax_obj.settings.pusher.app_key,
				cluster: wschat_ajax_obj.settings.pusher.cluster,
			}
        },
        is_admin: true,
        plugins: [
        	DeletePlugin,
        	WoocommercePlugin,
        	SearchPlugin,
        	TagsPlugin,
        ],
        tags: wschat_ajax_obj.tags,
        alert: {
        	url: wschat_ajax_obj.settings.alert_tone_url
        },
        header: {
        	status_text: wschat_ajax_obj.settings.widget_status === 'online' ? wschat_ajax_obj.settings.header_online_text : wschat_ajax_obj.settings.header_offline_text,
        }
    });

    if (wschat_ajax_obj.settings) {
		for(let key in wschat_ajax_obj.settings.colors) {
			key && chat.$el.get(0).style.setProperty(key,  '#' +wschat_ajax_obj.settings.colors[key]);
		}
    }

    const chat_panel = chat.$el.find('.chat-panel');
    const conversation_panel = chat.$el.find('.conversation-list');
    const chat_panel_header = chat.$el.find('.chat-panel-header');
    const message_input = jQuery('#wschat_message_input');
    const MESSAGE_INFO = {
        min: 0,
        max: 0,
    };

    let PAST_REQUEST_IS_PENDING = false;
    let SCROLL_PAUSED = false;
    let DISABLE_SCROLL_LOCK = false;
    const SCROLL_OFFSET = 100;

    new ConversationBuilder(chat);

    chat.on(EVENTS.WSCHAT_ON_SET_CONVERSATION, (data) => {
        chat_panel.html('');
        data.user &&
            chat_panel_header.find('.username').text(data.user.meta.name);
        let info = chat.$el.find('.user-meta-info').html(UserMetaInfo);

        chat_panel_header.parent().removeClass('d-none')

		info.find('.name').html(data.user.meta.name);
		info.find('.browser').html(data.user.meta.browser);
		info.find('.os').html(data.user.meta.os);
		info.find('.device').html(data.user.meta.device);
		info.find('.url').html(data.user.meta.current_url);


		chat.trigger(EVENTS.WSCHAT_ON_RENDER_USER_META, info);

		const agents = info.find('.conversation-agents');
		const agents_dropdown = info.find('.conversation-agents-control');

		agents.html('')
		agents_dropdown.html('')

		data.participants.forEach(agent => {
			agents.append('<li class="list-group-item">' + agent.display_name + '</li>');
		});

		data.agents.forEach(agent => {
			agents_dropdown.append(`<option value="${agent.ID}">${agent.display_name}</option> `);
		});

        message_input.focus();
        MESSAGE_INFO.min = 0;
        MESSAGE_INFO.max = 0;
        DISABLE_SCROLL_LOCK = true;

        setTimeout(() => DISABLE_SCROLL_LOCK = false, 1000);
    });

    chat.$el.on('click', '.add_agent_to_conversation', function () {
    	const agents = jQuery('.conversation-agents-control');

    	chat.connector.join_conversation(chat.conversation.id, agents.val());
    });

    chat.on(EVENTS.WSCHAT_ON_FETCH_MESSAGES, (data) => {
        for (let i = 0; i < data.messages.length; i++) {
            let row = data.messages[i];

            if (row.is_agent === true) {
                BUBBLE_TEMPLATE_DEFAULTS['{{OFFSET}}'] = 'offset-lg-6 offset-md-3 offset-xs-2';
                BUBBLE_TEMPLATE_DEFAULTS['{{POS}}'] = 'right';
            } else {
                BUBBLE_TEMPLATE_DEFAULTS['{{OFFSET}}'] = '';
                BUBBLE_TEMPLATE_DEFAULTS['{{POS}}'] = 'left';
            }
            BUBBLE_TEMPLATE_DEFAULTS['{{MESSAGE_ID}}'] = row.id;
            BUBBLE_TEMPLATE_DEFAULTS['{{CONTENT}}'] = row.body.formatted_content;
            BUBBLE_TEMPLATE_DEFAULTS['{{TIMESTAMP}}'] = formatDate(row.created_at);

            let row_template = CHAT_BUBBLE_TEMPLATE;

            row_template = row_template.replace(new RegExp(Object.keys(BUBBLE_TEMPLATE_DEFAULTS).join('|'), 'g'), match => BUBBLE_TEMPLATE_DEFAULTS[match]);
            row_template = jQuery(row_template);

            if (MESSAGE_INFO.min === 0) {
                chat_panel.append('<span data-message-id="0"></span>');
            }

            if (MESSAGE_INFO.min > row.id) {
                chat_panel.find('[data-message-id='+MESSAGE_INFO.min+']').before(row_template);
                MESSAGE_INFO.min = row.id;
            }

            if (MESSAGE_INFO.max === 0 || MESSAGE_INFO.max < row.id) {
                chat_panel.find('[data-message-id='+MESSAGE_INFO.max+']').after(row_template);
                MESSAGE_INFO.max = row.id;
                scrollIfNotPaused();
            }

            chat.trigger(EVENTS.WSCHAT_ON_RENDER_MESSAGE, {message_item: row_template, row});

            if (MESSAGE_INFO.min === 0) {
               scrollIfNotPaused();
            }

            MESSAGE_INFO.min = MESSAGE_INFO.min || row.id;
            MESSAGE_INFO.max = MESSAGE_INFO.max || row.id;

    		if (chat.scroll_to == row.id) {
				setTimeout(() => {
					jQuery('.message-item.bg-warning').removeClass('bg-warning')
					const el = jQuery('.message-item[data-message-id='+row.id+']').addClass('bg-warning');
                    if (el.length) {
                        const top = el.offset().top - 500;
                        chat_panel.scrollTop(chat_panel.scrollTop() +  top);
                    }
				}, 500)
    		}
        }

        if (DISABLE_SCROLL_LOCK === true) {
            scrollIfNotPaused();
        }

    });

    chat.on(EVENTS.WSCHAT_ON_PONG, (data) => {
        let drawer = chat_panel_header.find('.friend-drawer');
		let row_template = conversation_panel.find('[data-conversation-id='+data.id+']');
		let row_unread_count = row_template.find('.unread-count');
		let header_unread_count = chat_panel_header.find('.unread-count');

        data.status && chat_panel_header.find('.status').text(data.status).removeClass('online offline').addClass(data.status.toLowerCase());
        header_unread_count.text(data.unread_count);
		row_unread_count.text(data.unread_count || '');

        if (data.unread_count) {
            header_unread_count.removeClass('d-none');
        } else {
            header_unread_count.addClass('d-none');
        }

        if (data.is_online) {
            drawer.addClass('online');
            row_template.addClass('online');
        } else {
            drawer.removeClass('online');
            row_template.removeClass('online');
        }
    });

    const scrollIfNotPaused = (offset) => {
        if (SCROLL_PAUSED === false || DISABLE_SCROLL_LOCK === true) {
            console.log({test: chat_panel[0].scrollHeight, offset})
            chat_panel[0].scrollTop = chat_panel[0].scrollHeight + (offset || 0);
        }
    }

    const send_btn = jQuery('#wschat_send_message').on('click', function() {
        let msg = message_input.val();

        if (msg.trim() === '' && chat.trigger(EVENTS.WSCHAT_CAN_SEND_EMPTY_MESSAGE, false, true) === false) {
            return false;
        }

        chat.send_message({
            // Type is text by default now, it needs to changed based on the selection content
            wschat_ajax_nonce: wschat_ajax_obj.nonce,
            type: 'text',
            'content[text]': message_input.val()
        });
        message_input.val('').focus();
    });

    message_input.keyup(function(e) {
        e.key === 'Enter' && send_btn.click();
    });

    chat.$el.find('.search-messages').keyup(function(e) {
        if (e.key !== 'Enter' || this.value.trim() === '') {
			return;
		}

        chat.connector.get_messages({
        	after: 0,
        	before: 0,
            search: this.value
        });

    });

    message_input.on('focus', function() {
        let unread_count = chat_panel_header.find('.unread-count').text();

        if (parseInt(unread_count) > 0) {
        	chat.trigger(EVENTS.WSCHAT_ON_READ_ALL_MESSAGE);
        }
    });

    chat_panel_header.on('click', '.user-meta-info-toggle', function () {
    	chat.$el.find('.conversation-wrapper .user-meta-info').toggleClass('d-none');
    	chat.$el.find('.conversation-wrapper .wschat-search-container').addClass('d-none');
    });

    chat_panel_header.on('click', '.search-box-toggle', function () {
    	chat.$el.find('.conversation-wrapper .user-meta-info').addClass('d-none');
    	chat.$el.find('.conversation-wrapper .wschat-search-container').toggleClass('d-none');
    	chat.$el.find('.conversation-wrapper .wschat-search-container #wschat-search-input').focus();
    });

    conversation_panel.on('click', '[data-conversation-id]', function() {
        chat_panel.html('');
        let item = jQuery(this);
        let converssation_id = item.data('conversation-id');
        conversation_panel.find('[data-conversation-id]').removeClass('active');
        item.addClass('active')
        chat.connector.join_conversation(converssation_id);
    });

    chat_panel.on('scroll', function () {
        if (DISABLE_SCROLL_LOCK) {
            SCROLL_PAUSED = false;
            return;
        }
        if (this.scrollTop < SCROLL_OFFSET) {
            if (PAST_REQUEST_IS_PENDING === false) {
                PAST_REQUEST_IS_PENDING = true;
                chat.connector.get_messages({
                    after: 0,
                    before: MESSAGE_INFO.min
                });
                setTimeout(() => PAST_REQUEST_IS_PENDING = false, 500);
            }
        }

        if (this.offsetHeight + this.scrollTop >= this.scrollHeight - SCROLL_OFFSET) {
            SCROLL_PAUSED = false;
        } else {
            SCROLL_PAUSED = true;
        }
    });


    const emojiPicker = document.getElementById('wschat_emoji_picker');
    const emoji = new EmojiButton({
        style: 'twemoji',
        rootElement: emojiPicker.parentElement,
        position: 'top'
    });


    emojiPicker.addEventListener('click', function() {
        emoji.togglePicker();
    });

    emoji.on('emoji', function(selection) {
        message_input.val(message_input.val() + selection.emoji).focus();
        setTimeout(() => message_input.focus(), 500)
    });


    // Attachment toggler
    chat.$el.find('#attachment_picker').click(function (e) {
        e.preventDefault();
        chat.$el.find('.attachment-list').toggleClass('show d-none');
    });
    chat.$el.find('.attachment-list').on('click','button', function () {
        chat.$el.find('#attachment_picker').click();
    });
});
